angular.module('zc.projects')

.directive 'zcSegmentCookieEditor', (ProjectSegmentCookie, Meta, BaseProjectCrudEditor) ->

  class SegmentCookieEditor extends BaseProjectCrudEditor
    link: (scope, element, attrs) ->

  editor = new SegmentCookieEditor(
    ProjectSegmentCookie
    Meta
    '/templates/projects.settings/campaign/segment_cookie_editor.html'
  )

  return editor.createDirective()



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.settings/campaign/segment_cookie.directive.coffee